import { Stack, TopProject } from '../../types/globalTypes';
import { API_BASE_URL } from '../../constants';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface PortfolioData {
  portfolioHeader: any;
  projects: Array<TopProject>;
  stacks: Stack;
}

interface ApiResponse {
  data: PortfolioData;
}

const usePortfolioData = () => {
  const fetchData = async () => {
    const response = await axios.get<ApiResponse>(
      `${API_BASE_URL}/portfolio_page`
    );
    return response.data;
  };

  const { data, error } = useQuery({
    queryKey: ['portfolio_page'],
    queryFn: fetchData,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000, 
    refetchOnWindowFocus: false, 
    refetchOnMount: false, 
    refetchOnReconnect: false,
  });

  return { portfolioData: data?.data, error };
};

export default usePortfolioData;
